// extracted by mini-css-extract-plugin
export default {"Title":"ConfirmationModal_Title__aMCUS","Logo":"ConfirmationModal_Logo__8vBZV","Body":"ConfirmationModal_Body__73QY5"};